document.querySelectorAll<HTMLElement>(".modal-pdf").forEach(item => {
    const iframe = item.querySelector<HTMLIFrameElement>("iframe")!;

    iframe?.contentWindow?.addEventListener("load", () => {
        updateIframe(iframe);
    });

    // events
    item.addEventListener('shown.bs.modal', function (event) {
        updateIframe(iframe);
    });
});
function updateIframe(iframe: HTMLIFrameElement) {
    const img = iframe.contentWindow?.document.querySelector("img");
    if (img) {
        img.style.width = '100%';
    }
}
export default undefined;
